import { render, staticRenderFns } from "./Expenditure.vue?vue&type=template&id=742e4d76&scoped=true&"
import script from "./Expenditure.vue?vue&type=script&lang=js&"
export * from "./Expenditure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742e4d76",
  null
  
)

export default component.exports